module.exports = __webpack_public_path__ + "img/qrcode_east.60c1855e.png";